<template>
  <TransparentCard container-class="box_prize">
    <h3>{{ $_translations.value[title] }}</h3>

    <p>{{ $_translations.value[description] }}</p>

    <div class="prize_single_img">
      <div class="img_placeholder">
        <BaseImage :src="imageSrc" alt="prize" />
      </div>
    </div>

    <div class="flex-row">
      <p>{{ item.headline }}</p>

      <a href="#" @click.prevent="$emit('show:howToWin')">
        {{ $_translations.value.page_prizes_item_how_to_win }}
      </a>
    </div>
  </TransparentCard>
</template>

<script setup>
import { computed } from 'vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import { prizeTypeEnum } from '@/constants/winners.js';

const imageSrcMap = {
  [prizeTypeEnum.GRAND]: '/static/images/prizes/prize_grand.png',
  [prizeTypeEnum.MONTHLY]: '/static/images/prizes/prize_monthly.png',
  [prizeTypeEnum.WEEKLY]: '/static/images/prizes/prize_weekly.png',
};

defineEmits(['show:howToWin']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const title = computed(() => `page_prizes_item_prize_title_${ props.item.type }`);
const description = computed(() => `page_prizes_item_prize_description_${ props.item.type }`);
const imageSrc = computed(() => props.item.imgUrl || imageSrcMap[props.item.type]);
</script>
